// extracted by mini-css-extract-plugin
export var arrow = "customerCard-module--arrow--a650c";
export var contentWrapper = "customerCard-module--contentWrapper--1f8e1";
export var copy = "customerCard-module--copy--6e8fd";
export var curtain = "customerCard-module--curtain--00416";
export var customerCardOuter = "customerCard-module--customerCardOuter--46c4a";
export var logo = "customerCard-module--logo--11b35";